import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('settings', app)

  store.actions.checkIfRefreshIsNeeded = function (context) {
    //if it was loaded with only public settings then needs reload
    if (context.state.list.default.data.length < 15) {
      context.dispatch('list')
    }
  }
  store.getters.listByName = function (state) {
    const settingsByName = {}
    state.list.default.data.forEach((s) => {
      settingsByName[s['name']] = s
    })

    return settingsByName
  }

  store.getters.settings = function (state) {
    const settings = {}
    state.list.default.data.forEach((s) => {
      settings[s.name] = s.value
    })

    return settings
  }

  // #198 — single source of truth for the task-distribution gate, so the rule
  // lives in one place instead of being copy-pasted across components.
  // hasTaskDistribution is the raw flag (used where the route already gates on
  // admin, e.g. the peopleACL views); taskDistributionVisible is the full gate
  // (admin + feature on + cost centers on) used to show the treasury-list and
  // nav affordances.
  store.getters.hasTaskDistribution = function (state, getters) {
    return getters.listByName?.hasTaskDistribution?.value === 'true'
  }

  store.getters.taskDistributionVisible = function (state, getters, rootState, rootGetters) {
    const s = getters.listByName
    return (
      rootGetters['auth/isAdmin'] === true &&
      s?.hasTaskDistribution?.value === 'true' &&
      s?.treasuryHasCostCenters?.value === 'true'
    )
  }
  store.getters.orgType = function (state) {
    let v = ''
    state.list.default.data.find((s) => {
      if (s.name === 'orgType') {
        v = s.value
        return true
      }
    })
    return v
  }

  store.getters.client = function (state) {
    let v = ''
    state.list.default.data.find((s) => {
      if (s.name === 'client') {
        v = s.value
        return true
      }
    })
    return v
  }
  store.getters.filesDir = function (state) {
    let v = ''
    state.list.default.data.find((s) => {
      if (s.name === 'filesDir') {
        v = s.value
        return true
      }
    })
    return v
  }
  // #261 — may the «Pedido de Pagamento» emails be sent. An ordinary settings
  // row an admin toggles from the Mensagens settings page; it replaced the
  // read-only `automatedMemberPayments` flag the API derived from the
  // HAS_IFTHENPAY (then HAS_AUTOMATED_MEMBER_PAYMENTS) config, which also meant
  // "this org has ifThenPay credentials" and so could not be changed from the UI.
  //
  // Anything other than "true" is false, including a missing row — mirroring
  // outboundEmails.PaymentRequestsAreSent, so the UI never claims reminders are
  // going out when the API would hold them.
  // #261 — does this org have ifThenPay credentials. Read-only, derived by the
  // API from the HAS_IFTHENPAY config. This is the OTHER half of what the old
  // `automatedMemberPayments` flag conflated: it gates the Multibanco / MB WAY
  // payment page, which needs an account, not an administrator's permission.
  store.getters.hasIfThenPay = function (state) {
    let v = ''
    state.list.default.data.find((s) => {
      if (s.name === 'hasIfThenPay') {
        v = s.value
        return true
      }
    })
    return v === 'true'
  }
  store.getters.sendPaymentRequests = function (state) {
    let v = ''
    state.list.default.data.find((s) => {
      if (s.name === 'sendPaymentRequests') {
        v = s.value
        return true
      }
    })
    return v === 'true'
  }

  // #243 — whether the «Secções a que se candidata» block appears on the public
  // inscrição form, and whether it must be filled in. Mirrors
  // settings.MemberApplicationSectionsMode in the API, ceiling and all: an
  // association is always 'hidden' whatever the row says, because sections exist
  // only for cooperatives, and within a cooperative an unrecognised or missing
  // value falls back to 'required' — the behaviour every org had before the
  // setting existed, so a settings response that has not arrived yet cannot
  // flash a field away.
  //
  // Kept here rather than in the component because the public form and the
  // settings page must agree, and only one of them is behind a login.
  store.getters.memberApplicationSectionsMode = function (state, getters) {
    if (getters.orgType !== 'cooperative') return 'hidden'
    const v = getters.listByName?.memberApplicationSectionsMode?.value
    if (v === 'required' || v === 'optional' || v === 'hidden') return v
    return 'required'
  }

  store.getters.memberApplicationSectionsVisible = function (state, getters) {
    return getters.memberApplicationSectionsMode !== 'hidden'
  }

  window.addEventListener('ws:settings', (e) => {
    if (e.detail === 'updated') {
      window.vue.$store.dispatch('settings/list')
    }
  })
  return store
}
